export default __webpack_public_path__ + "static/media/PlanificacionVac2025.3abde282.jpg";